export var petriUrlMap = {
    new: {
        conductAllInScope: '/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/v1/laboratory/platform/conductExperiment',
    },
    old: {
        conductAllInScope: '/_api/wix-laboratory-server/laboratory/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/laboratory/conductExperiment',
    },
};
export var getAllInScopePath = function (scope, useNewApi) {
    if (scope === void 0) { scope = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? "".concat(petriUrlMap.new.conductAllInScope, "?scope=").concat(encodeURIComponent(scope))
        : "".concat(petriUrlMap.old.conductAllInScope, "?scope=").concat(encodeURIComponent(scope));
    return urlApi;
};
export function isValidScopeUrl(url, useNewApi) {
    return (url.indexOf(useNewApi
        ? petriUrlMap.new.conductAllInScope
        : petriUrlMap.old.conductAllInScope) !== -1);
}
export var getExperimentPath = function (key, fallback, useNewApi) {
    if (key === void 0) { key = ''; }
    if (fallback === void 0) { fallback = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? "".concat(petriUrlMap.new.conductExperiment, "?key=").concat(encodeURIComponent(key), "&fallbackValue=").concat(encodeURIComponent(fallback))
        : "".concat(petriUrlMap.old.conductExperiment, "?key=").concat(encodeURIComponent(key), "&fallback=").concat(encodeURIComponent(fallback));
    return urlApi;
};
export function isUrlOfExperiment(url, specName, useNewApi) {
    var pattern = "".concat(getExperimentPath(specName, '', useNewApi));
    return url.includes(pattern);
}
//# sourceMappingURL=urlMap.js.map